export const camposAsignarRequerimiento = (requerimientos = [], logros = [], pokemones = [], idPokemon = null) => {
  return {
    title: null,
    campos: [
      {
        name: "idPokemon",
        label: "Id Pokémon",
        type: "number",
        defaultValue: idPokemon,
        hidden: true,
      },
      {
        name: "idPokemonDestino",
        label: "Pokémon al que evoluciona",
        type: "select",
        opciones: pokemones,
        placeholder: "Seleccione el Pokémon al que evoluciona",
        rules: [
          {
            required: true,
            message: "Debe seleccionar el Pokémon destino de la evolución",
          },
        ],
        help: "Seleccione el Pokémon resultante después de la evolución",
      },
      {
        name: "idRequerimientoEvolucion",
        label: "Tipo de Requerimiento",
        type: "select",
        opciones: requerimientos,
        placeholder: "Seleccione el tipo de requerimiento necesario",
        rules: [
          {
            required: true,
            message: "Debe seleccionar un tipo de requerimiento para la evolución",
          },
        ],
      },
      {
        name: "idLogro",
        label: "Logro Específico",
        type: "select",
        opciones: logros,
        placeholder: "Seleccione un logro específico (opcional)",
        help: "Si el requerimiento necesita un logro específico, selecciónelo aquí",
      },
    ],
  };
};
